class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelectorAll('.modal__close-button, .search-modal__close-button, button[type="button"]').forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });
    this.detailsContainer.addEventListener('toggle', () => {
      if (!this.isOpen()) {
        this.close(false);
      }
    });

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (event.target.closest('.header__mobile-search-trigger')) return;
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const details = (event && event.target) ? event.target.closest('details') : this.detailsContainer;
    (details || this.detailsContainer).setAttribute('open', true);
    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    });
    document.body.classList.add('overflow-hidden', 'search-modal--open');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden', 'search-modal--open');
  }
}

customElements.define('details-modal', DetailsModal);
